export default "__VITE_ASSET__8OOa7lRe__"